import { queryOptions } from "@tanstack/react-query";
import type { TenantQueryKey } from "#/modules/util.fetch-client/tenant-query-key";
import { getLesplanning, getPlanningKlassen } from "#/modules/les.planning/planning.functions";
import type { PlanningRange } from "#/modules/les.planning/domain/les";
import { getJaarplanning } from "#/modules/les.planning/jaarplanning.functions";
import { getRooster } from "#/modules/les.planning/rooster.functions";
import { getVakanties } from "#/modules/les.planning/vakanties.functions";

export const PLANNING_QUERY_KEY = "lesplanning";
export const PLANNING_KLASSEN_QUERY_KEY = "lesplanning-klassen";
export const ROOSTER_QUERY_KEY = "rooster";
export const JAARPLANNING_QUERY_KEY = "jaarplanning";

export function planningQueryOptions(tenant: TenantQueryKey, range: PlanningRange) {
  return queryOptions({
    queryKey: [tenant, PLANNING_QUERY_KEY, range] as const,
    queryFn: () => getLesplanning({ data: range }),
    staleTime: 30_000,
  });
}

export function planningKlassenQueryOptions(tenant: TenantQueryKey) {
  return queryOptions({
    queryKey: [tenant, PLANNING_KLASSEN_QUERY_KEY] as const,
    queryFn: () => getPlanningKlassen(),
    staleTime: 5 * 60_000,
  });
}

export function roosterQueryOptions(tenant: TenantQueryKey) {
  return queryOptions({
    queryKey: [tenant, ROOSTER_QUERY_KEY] as const,
    queryFn: () => getRooster(),
    staleTime: 60_000,
  });
}

export function jaarplanningQueryOptions(tenant: TenantQueryKey) {
  return queryOptions({
    queryKey: [tenant, JAARPLANNING_QUERY_KEY] as const,
    queryFn: () => getJaarplanning(),
    staleTime: 60_000,
  });
}

export const VAKANTIES_QUERY_KEY = "vakanties";

export function vakantiesQueryOptions(tenant: TenantQueryKey) {
  return queryOptions({
    queryKey: [tenant, VAKANTIES_QUERY_KEY] as const,
    queryFn: () => getVakanties(),
    staleTime: 60_000,
  });
}
